import { render, staticRenderFns } from "./LoadingState.vue?vue&type=template&id=488c1380&"
import script from "./LoadingState.vue?vue&type=script&lang=js&"
export * from "./LoadingState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports